export default __webpack_public_path__ + "static/media/client-04.98884207.svg";